/* @jsx h */
import { createTRPCProxyClient, httpBatchLink, httpLink } from "@trpc/client";
import type { AppRouter } from "@app/server/trpc/router";
import { defineComponent, h, inject, provide } from "vue";

export type TrpcClient = ReturnType<typeof createTRPCProxyClient<AppRouter>>;

export interface TrpcContextType {
  trpc: TrpcClient;
}

const TrpcContextKey = Symbol("TrpcContext");

export const TrpcProvider = defineComponent({
  name: "TrpcProvider",
  setup(_, { slots }) {
    const trpcClient = createTRPCProxyClient<AppRouter>({
      links: [
        httpLink({
          url: "/api/trpc",
        }),
      ],
    });

    provide(TrpcContextKey, { trpc: trpcClient });

    return () => slots.default?.();
  },
});

export function useTRPC(): TrpcClient {
  const context = inject<TrpcContextType>(TrpcContextKey);
  if (!context) {
    throw new Error("useTRPC must be used within a TrpcProvider");
  }
  return context.trpc;
}

export const useTrpc = useTRPC;
